//
// Module for the Member Statement Messages Index view
//
rs.module("fund/configuration/memberstatementmessages/index",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(grid, jsSelectors, ajaxUrls, columnIds) {

            var statementMessagesForm = $.js(jsSelectors.statementMessagesForm);

            var statementMessageKey = statementMessagesForm.js(jsSelectors.statementMessageKey);
            var statementMessageUpdateToken = statementMessagesForm.js(jsSelectors.statementMessageUpdateToken);
            var messageName = statementMessagesForm.js(jsSelectors.messageName);
            var messageText = statementMessagesForm.js(jsSelectors.messageText);
            var addStatementMessageLink = statementMessagesForm.js(jsSelectors.addStatementMessageLink);
            var cancelStatementMessageButton = statementMessagesForm.js(jsSelectors.cancelStatementMessageButton);

            if (grid) {

                // Register add/cancel click handlers
                addStatementMessageLink.on("click", addStatementMessageClicked);
                cancelStatementMessageButton.on("click", cancelStatementMessageClicked);

                // Register grid selection changed handler
                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();

                        $.get(
                            ajaxUrls.getStatementMessageForUpdate,
                            { statementMessageKey: rows[0][columnIds.statementMessageKey] },

                            function (data) {
                                statementMessageKey.val(data.statementMessageKey);
                                messageName.clearErrors().val(data.messageName);
                                messageText.clearErrors().val(data.messageString);
                                statementMessageUpdateToken.val(data.updateToken);
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });

                // clear errors, current values, and grid selection when add is clicked
                function addStatementMessageClicked() {
                    eventBanner.removeAllMessages();

                    messageName.val('').clearErrors();
                    messageText.val('').clearErrors();

                    statementMessageKey.val(-1);

                    grid.selectedValues = null;
                }

                // clear errors and select first grid row when cancel is clicked
                function cancelStatementMessageClicked() {
                    eventBanner.removeAllMessages();

                    grid.selectedValues = null;
                    grid.selectFirstRow();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);